import { format } from "date-fns";
import { CalendarClock, Clock } from "lucide-react";
import { useTranslate } from "ra-core";

import { cn } from "@/lib/utils";

import { useDateLocale } from "../../personal/useDateLocale";
import type { Task } from "../../types";

/** Due date (red when overdue) and hours of a task, on one line. */
export const TaskMeta = ({ task }: { task: Task }) => {
  const translate = useTranslate();
  const { dateFnsLocale } = useDateLocale();
  const isOverdue =
    !!task.due_date && !task.done_date && new Date(task.due_date) < new Date();
  const hasHours = task.estimated_hours != null || task.spent_hours != null;

  return (
    <span className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
      {task.due_date && (
        <span
          className={cn(
            "flex items-center gap-1",
            isOverdue && "text-destructive",
          )}
          title={
            isOverdue ? translate("crm.operations.tasks.overdue") : undefined
          }
        >
          <CalendarClock className="size-3" />
          {format(new Date(task.due_date), "PP p", { locale: dateFnsLocale })}
        </span>
      )}
      {hasHours && (
        <span className="flex items-center gap-1">
          <Clock className="size-3" />
          {translate("crm.operations.tasks.hours", {
            spent: task.spent_hours ?? 0,
            estimated: task.estimated_hours ?? 0,
          })}
        </span>
      )}
    </span>
  );
};
